import styled from 'styled-components';

export const Container = styled.div`
  overflow: hidden;
  padding-right: 0.5rem;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 9999;
`;
